import React, { useEffect, useMemo, useState } from 'react';

import Tippy from '@tippyjs/react';
import cs from 'classnames';

import Counter from '../Counter/Counter';
import Icon from '../Icon/Icon';

import ActionWrapper from './components/ActionWrapper/ActionWrapper';
import { DEFAULT_ACTIONS } from './lib/actions';

const ExpandableToolbar = ({
  id,
  actions = [],
  fetchData = () => {},
  category,
  className,
  setIsToolbarOpen = () => {}
}) => {
  const [selectedAction, setSelectedAction] = useState(null);

  const allActions = useMemo(() => [...DEFAULT_ACTIONS, ...actions], [actions]);

  const activeAction = useMemo(() => {
    return allActions.find((action) => action.id === selectedAction?.id);
  }, [allActions, selectedAction?.id]);

  const onActionToggle = (action) => {
    setSelectedAction((prevAction) => (prevAction?.id === action?.id ? null : action));
  };

  useEffect(() => {
    setIsToolbarOpen(!!activeAction);
  }, [activeAction, setIsToolbarOpen]);

  return (
    <div className={cs('relative flex h-full flex-row-reverse', className)}>
      <div className="min-w-14 border-l border-solid border-white border-l-neutral-100  bg-white pt-12">
        <div className="flex flex-col items-center gap-6">
          {allActions.map((action) => (
            <Tippy key={action.id} content={action.name} placement="left" className="tippy-dark">
              <div
                className={cs(
                  'relative flex h-8 w-8 cursor-pointer items-center justify-center rounded',
                  action.color && 'bg-neutral-50 hover:bg-primary-50',
                  activeAction?.id === action.id && 'bg-primary-50'
                )}
                onClick={() => onActionToggle(action)}>
                <Counter count={action.count}>
                  <Icon
                    icon={action.icon}
                    className="cursor-pointer"
                    size={24}
                    color={activeAction?.id === action.id ? 'primary' : 'neutral'}
                  />
                </Counter>
              </div>
            </Tippy>
          ))}
        </div>
      </div>
      {activeAction && (
        <ActionWrapper title={activeAction.name} onClose={() => setSelectedAction(null)}>
          {React.cloneElement(activeAction.component, { ...activeAction, id, fetchData, category })}
        </ActionWrapper>
      )}
    </div>
  );
};

export default ExpandableToolbar;
